function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { Callout, Typography } from 'seagull';
import { useIoContext } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { getServiceBulletPoints } from "../../../utils/service-description/getServiceBulletPoints";
import styles from "./BulletPointsSection.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function BulletPointsSection(props) {
  const {
    testid
  } = props;
  const {
    getNow
  } = useIoContext();
  const now = useMemo(() => getNow(), []);
  const featureFlags = useFeatureFlags();
  const bulletPoints = getServiceBulletPoints(_objectSpread(_objectSpread({}, props), {}, {
    now,
    featureFlags
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("ul", {
      children: bulletPoints.bullets.map((text, idx) => /*#__PURE__*/_jsxs(Typography, {
        noWrap: false,
        as: "li",
        "data-testid": testid + "bullet-".concat(idx),
        className: styles.listItem,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.bullet
        }), text]
      }, idx))
    }), bulletPoints.pausedCallout && /*#__PURE__*/_jsx(Callout, {
      className: styles.section,
      withBorder: true,
      children: bulletPoints.pausedCallout
    })]
  });
}